import React from "react";
import PropTypes from "prop-types";
import { formatCurrencyWithSign } from "../../utils/utils";
import {
  CURRENCY_FORMAT,
  NEGATIVE_SIGN,
  ZERO_NUMBER
} from "../../utils/constants/appConstants";
import "./reportSummaryTotals.scss";

/**
 * A row of report totals. One item can be marked as the headline figure, which gets the
 * mint total treatment from the UI spec.
 *
 * Money items are formatted as currency. A count item is written as it is given.
 */
const ReportSummaryTotals = ({ heading, items }) => (
  <div className="report-summary-totals">
    {heading && <div className="summary-heading">{heading}</div>}
    <div className="summary-items">
      {items.map((item) => {
        const isNegative =
          item.isCurrency !== false && item.value < ZERO_NUMBER;
        const valueClassName = isNegative
          ? "summary-value summary-value-negative"
          : "summary-value";

        let displayValue = item.value;
        if (item.isCurrency !== false) {
          displayValue = `${isNegative ? NEGATIVE_SIGN : ""}${CURRENCY_FORMAT}${formatCurrencyWithSign(Math.abs(item.value ?? ZERO_NUMBER))}`;
        }

        return (
          <div
            key={item.label}
            className={
              item.isTotal ? "summary-item summary-item-total" : "summary-item"
            }
          >
            <span className="summary-label">{item.label}</span>
            <span className={valueClassName}>{displayValue}</span>
          </div>
        );
      })}
    </div>
  </div>
);

ReportSummaryTotals.propTypes = {
  heading: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      /** false renders the value as it is, for a count rather than an amount */
      isCurrency: PropTypes.bool,
      /** true gives the item the headline treatment */
      isTotal: PropTypes.bool
    })
  ).isRequired
};

export default ReportSummaryTotals;
